export default "__VITE_ASSET__BnO$2dkJ__"